import { render, staticRenderFns } from "./InvitacionesDetalle.vue?vue&type=template&id=5bf1d210"
import script from "./InvitacionesDetalle.vue?vue&type=script&lang=js"
export * from "./InvitacionesDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports